import { type CombinedGraphQLErrors } from '@apollo/client/core';

export function pathIncludes(error: CombinedGraphQLErrors, string: string): boolean {
  return (
    error.errors &&
    error.errors.some((error) => {
      return error.path && error.path.indexOf(string) > -1;
    })
  );
}
